import React from "react";
import { getVal, setVal } from "oolib";
import { ConfigForm_SectionWrapper } from "../../WidgetMetricCard/ConfigForm/ConfigForm_SectionWrapper";
import { CollapseTransition } from "../../utils/CollapseTransition";
import { CombineSegmentsControl, SwitchRow } from "../../utils/CombineSegmentsControl";
import { useCombineSegments } from "../../utils/useCombineSegments";
import { usePieChartConfig } from "./ConfigForm_Context";
import { useReportLandingContext } from "../../../../ReportLandingContext";
import { DEFAULT_MAX_SEGMENTS, MIN_SEGMENTS } from "../constants";
import { hasTagInputDim, TAG_INPUT_HIDE_ZERO_TOOLTIP } from "../../utils/WIDGET_COMPATIBLE_COMPS";

export const ConfigForm_DisplaySection = () => {
  const { widgetConfig, dataKeys, updateWidget, pieChartType } = usePieChartConfig();
  const tagInput = hasTagInputDim(widgetConfig.props);
  const { widgetDataStore } = useReportLandingContext();

  // Combine segments only applies to single-layer pies, and only once a data field
  // is added. Multi-layer pies render nested children, which this can't collapse.
  const isVisible = pieChartType === "singleLayer" && !!getVal(widgetConfig, dataKeys.dimension1);

  const combineSegments = useCombineSegments({
    widgetConfig,
    dataKeys,
    updateWidget,
    data: widgetDataStore?.[widgetConfig.id],
    isEnabled: isVisible,
    defaultMax: DEFAULT_MAX_SEGMENTS,
    min: MIN_SEGMENTS,
  });

  return (
    <ConfigForm_SectionWrapper icon="Eye" title="Display">
      <CollapseTransition isVisible={isVisible}>
        <CombineSegmentsControl
          label="Combine segments"
          countLabel="Number of segments"
          {...combineSegments}
        />
      </CollapseTransition>

      <SwitchRow
        id="hideZeroValues"
        label="Hide Zero Values"
        value={tagInput || !!getVal(widgetConfig, dataKeys.hideZeroValues)}
        onChange={(next) => updateWidget(w => setVal(w, dataKeys.hideZeroValues, next))}
        disabledTooltip={tagInput ? TAG_INPUT_HIDE_ZERO_TOOLTIP : undefined}
      />
    </ConfigForm_SectionWrapper>
  );
};
